import {computed, decorate, observable} from 'mobx';
import {faRuler} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';
import {displayableProperty} from './displayableProperty';
import i18n from '../i18n/i18n';
import {displayablePropertyParam} from './displayablePropertyParam';

export class UnitOfMeasurement extends BaseModel {
  static faIcon = faRuler;

  searchableProperties = ['name', 'label'];

  displayableProperties = [
    displayableProperty({
      key: 'name',
      title: i18n.t('unitOfMeasurement.model.attributes.name.label'),
      params: [displayablePropertyParam({path: 'name'})],
      template: '{value}',
    }),
    displayableProperty({
      key: 'label',
      title: i18n.t('unitOfMeasurement.model.attributes.label.label'),
      params: [displayablePropertyParam({path: 'label'})],
      template: '{value}',
    }),
  ];

  get isPercent() {
    return this.label === '%';
  }
}

decorate(UnitOfMeasurement, {
  id: observable,
  name: observable,
  label: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  isPercent: computed,
});

/* Translation
 * t('unitOfMeasurement.types.KG')
 * t('unitOfMeasurement.types.G')
 * t('unitOfMeasurement.types.PCE')
 * t('unitOfMeasurement.types.CU')
 * t('unitOfMeasurement.types.TU')
 * t('unitOfMeasurement.types.LU')
 */
export const UnitOfMeasurementType = {
  KG: 'KG',
  G: 'G',
  PCE: 'PCE',
  CU: 'CU',
  TU: 'TU',
  LU: 'LU',
};
